import axios from 'axios'
import qs from 'qs'
import Configs from './configs'
import store from '../store'
import Vue from 'vue'
import layer from 'vue-layer'

let $layer = layer(Vue)

let cancel
let promiseArr = {}
const CancelToken = axios.CancelToken
// 请求拦截器
axios.interceptors.request.use(config => {
	// 发起请求时，取消掉当前正在进行的相同请求
	if (promiseArr[config.url]) {
		promiseArr[config.url]('操作取消')
		promiseArr[config.url] = cancel
	} else {
		promiseArr[config.url] = cancel
	}
	if (store.getters['Loading/IsEnable']) {
		store.dispatch('Loading/Loading');
	}
	var userInfo = JSON.parse(window.localStorage.getItem('user') || null);
	if (!!userInfo) {
		config.headers['SessionToken'] = userInfo.Token;
	}
	return config
}, error => {
	return Promise.reject(error)
})

// 响应拦截器即异常处理
axios.interceptors.response.use(response => {
	if (store.getters['Loading/IsEnable']) {
		store.dispatch('Loading/Loaded');
	}
	return response
}, err => {
	if (store.getters['Loading/IsEnable']) {
		store.dispatch('Loading/Loaded');
	}
	if(err === undefined || err === null){
		let msg = '网络或服务器异常';
		$layer.msg(msg);
		return Promise.resolve(msg);
	}
	if (err && err.response) {
		switch (err.response.status) {
			case 400:
				err.message = '错误请求'
				break
			case 401:
				err.message = '未授权，请重新登录'
				break
			case 403:
				err.message = '拒绝访问'
				break
			case 404:
				err.message = '请求错误,未找到该资源'
				break
			case 405:
				err.message = '请求方法未允许'
				break
			case 408:
				err.message = '请求超时'
				break
			case 500:
				err.message = '服务器端出错(500)'
				break
			case 501:
				err.message = '网络未实现'
				break
			case 502:
				err.message = '网络错误'
				break
			case 503:
				err.message = '服务不可用'
				break
			case 504:
				err.message = '网络超时'
				break
			case 505:
				err.message = 'http版本不支持该请求'
				break
			default:
				err.message = `连接错误${err.response.status}`
		}
		$layer.msg(err.message)
	} else {
		if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
			return { data: { Status: false, Message : '网络超时'}, status:408, statusText:'timeout' };
		}
	}
	//return Promise.resolve(err.response)
})

axios.defaults.baseURL = Configs.BaseUrl
// 设置默认请求头
axios.defaults.headers = {
	'X-Requested-With': 'XMLHttpRequest'
}
axios.defaults.timeout = 20000

export default {
	// get请求
	get(url, param) {		
		return new Promise((resolve, reject) => {
			axios({
				method: 'get',
				url,
				params: param,
				cancelToken: new CancelToken(c => {
					cancel = c
				})
			}).then(res => {
				if (!!res) {
					resolve(res.data)
				}
			})
		})
	},
	// post请求
	post(url, param) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'post',
				url,
				timeout: 60000,
				data: qs.stringify(param),
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				cancelToken: new CancelToken(c => {
					cancel = c
				})
			}).then(res => {
				if (!!res) {
					resolve(res.data)
				}
			})
		})
	},
	ajax(config) {
		return new Promise((resolve, reject) => {
			axios({
				method: config.method || 'post',
				url: config.url,
				data: config.data,
				headers: config.headers || {},
				timeout: config.timeout || 90000,
				onUploadProgress: config.onUploadProgress,
				cancelToken: new CancelToken(c => {
					cancel = c
				})
			}).then(res => {
				console.log('then', res);
				if(!!res) {
					resolve(res.data)
				}
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/common/http.js